import React, { useState, useEffect } from "react";
import ApiService from "../../services/Api.service";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Alert from "../Alert/Alert";
import Pagination from "../Pagination/Pagination";
import StatusBadge from "../../utilities/StatusBadge";
import FilterBar from "../FilterBar/FilterBar";
import Loader from "../Loader/Loader";
import { Download } from "lucide-react";
import { downloadFromSignedUrl } from "../../utilities/DownloadFile";

export default function BulkRecrodingJobs() {
    const [Loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [sections, setSections] = useState([]);
    const [postsPerPage, setPostsPerPage] = useState(20);
    const [headers, setHeaders] = useState([]);
    const [dropDownData, setDropDownData] = useState([]);
    const [campaignOptions, setCampaignOptions] = useState([]);
    const [activeCallId, setActiveCallId] = useState(null);

    const [pagination, setPagination] = useState({
        page: 1,
        size: 20,
        total: 0,
        total_pages: 0,
    });
    const [alertValue, setAlertValue] = useState({
        show: false,
        message: "",
        variant: "success",
        position: "middle",
    });
    const [selectedRowIndex, setSelectedRowIndex] = useState(null);

    const validationSchema = yup.object().shape({
    });

    const {
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            campaign_id: "",
            agents: [],
            products: [],
            search: "",
            date_from: "",
        }
    });


     const fetchDashboardData = async () => {
        try {
          setLoading(true);
          const campaignRes = await ApiService.getCampaignOptions();
          const campaignData = campaignRes?.data?.data || [];
    
          setCampaignOptions(campaignData);
        } catch (err) {
          console.error("Error loading dashboard data:", err);
        } finally {
          setLoading(false);
        }
      };

  useEffect(() => {
    fetchDashboardData();
  }, []);

    const fetchDetail = async (page = 1, size = postsPerPage, payload = null) => {
        try {
            setLoading(true);
            if (!payload) {
                payload = {
                    campaign_id:""
                };
            }
            const res = await ApiService.getRecordingJobs(payload, { page, size });
            if (res.status === 200 && res.data) {
                setTableData(res.data.data);
                setPagination(res.data.pagination);
                setHeaders(res.data.header);
                setSections(res.data.sections);
                setSelectedRowIndex(null);
                setLoading(false);
                setActiveCallId(null)
            }
            setActiveCallId(null)
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    };

    const fetchDropdownDetail = async () => {
        try {
            const subprocessRes = await ApiService.getSubprocesses();
            if (subprocessRes.status === 200) setDropDownData(subprocessRes.data)
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchDropdownDetail();
        fetchDetail();
    }, []);

    const handelSubmit = async (data) => {
        // Build payload from filter values (ignore empty strings and empty arrays)
        const payload = Object.fromEntries(
            Object.entries(data).filter(([_, v]) => {
                if (Array.isArray(v)) return v.length > 0;
                return v !== "" && v !== null && v !== undefined;
            })
        );
        fetchDetail(1, postsPerPage, payload);
    };


    const handleClearFilters = () => {
        reset({ campaign_id: "", agents: [], products: [], search: "", date_from: "" });
        fetchDetail();
        setActiveCallId(null)
    };

    const handlePageSizeChange = (e) => {
        const newSize = Number(e.target.value);
        setPostsPerPage(newSize);
        fetchDetail(1, newSize);
        setSelectedRowIndex(null);
        setActiveCallId(null)
    };

    const mistableTh = {
        backgroundColor:"transparent",
        color: "rgba(43, 58, 103, 1)",
        fontFamily: "Nunito",
        fontSize: "12px",
        fontWeight: 700,
        lineHeight: "16px",
        letterSpacing: "0.1em",
        textAlign: "center",
    };

    const tableTdStyles = {
        backgroundColor: "#F7F7F7",
        fontFamily: "Nunito",
        fontSize: "12px",
        fontWeight: "700",
        lineHeight: "16px",
        letterSpacing: "0em",
        textAlign: "center",
        color: "#232122",
    };

    // FilterBar fields (dummy data wired)
    const filterDefs = [
        { type: "text", name: "search", placeholder: "Search..." },
        { type: "select", name: "campaign_id", placeholder: "Select Campaign", options: campaignOptions },
        // { type: "multiselect", name: "agents", placeholder: "Select Agent - All", options: AGENT_OPTIONS },
        // { type: "multiselect", name: "products", placeholder: "Select Product - All", options: PRODUCT_OPTIONS },
        { type: "date", name: "start_date", placeholder: "Start Date" },
        { type: "date", name: "end_date", placeholder: "End Date" },

    ];
    const handleFetchSignedUrl = async (job_id) => {
    try {
        const res = await ApiService.getRecordingDownloadUrl(job_id);
        if (res.status === 200 && res.data) {
            const url = res.data.signed_url;
            await downloadFromSignedUrl(url); // download file
        }
    } catch (error) {
        console.error("Error fetching signed URL:", error);
        setAlertValue({
                show: true,
                message: error.response?.data?.detail || "Failed to create user",
                variant: "danger",
                position: "middle",
            });
    }
};


    return (
        <> {alertValue.show && (
            <Alert
                variant={alertValue.variant}
                message={alertValue.message}
                dismissible={true}
                timeout={2500}
                position={alertValue.position}
                onClose={() => setAlertValue({ show: false, message: "", variant: "" })}
            />
        )}

            <div className="main-contanier">
                
                <FilterBar
                    control={control}
                    handleSubmit={handleSubmit}
                    onSubmit={handelSubmit}
                    onClearFilters={handleClearFilters}
                    filters={[]}
                    title={"All Jobs"}
                    totalCount={pagination.total || 0}
                    tableId="table-id"
                    isDownload={false}
                />

                <div className="table-container dailymis-table" style={{ height: "400px", position: "relative" }}>
                    {Loading && <Loader fullScreen={false} message="Loading leads..." />}
                    <table id="table-id" className="custom-table-container">
                        <thead
                            className="table-head"
                            style={{ position: "sticky", top: "0", zIndex: "1" }}
                        >
                            <tr>
                                <th style={mistableTh}>S.No</th>
                                {headers.map((header, i) => (
                                    <th key={i} style={mistableTh}>
                                        {header.label}
                                    </th>
                                ))}
                                <th style={mistableTh}> Recording</th>
                            </tr>
                        </thead>

                        <tbody>
                            {tableData.length > 0 ? (
                                tableData.map((item, index) => (
                                    <React.Fragment key={index}>
                                        <tr
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                                setSelectedRowIndex(selectedRowIndex === index ? null : index)
                                            }
                                        >
                                            <td
                                                style={{
                                                    ...tableTdStyles,
                                                    backgroundColor:
                                                        selectedRowIndex === index ? "#f9faff" : "transparent",
                                                }}
                                            >
                                                {index + 1}
                                            </td>
                                            {headers.map((header, i) => (
                                                <td
                                                    key={i}
                                                    style={{
                                                        ...tableTdStyles,
                                                        backgroundColor:
                                                            selectedRowIndex === index ? "#f9faff" : "transparent",
                                                    }}
                                                    title={item[header.value] ?? "--"}
                                                >
                                                    {header.value === "status" ? (
                                                        <StatusBadge status={item.status} />
                                                    ) : header.value === "disposition" ? (
                                                        <StatusBadge status={item.disposition} />
                                                    ) : (
                                                        <span className="cell-ellipsis">{item[header.value] ?? "--"}</span>
                                                    )}
                                                    
                                                </td>
                                                
                                            ))}
                                            <td
                                                style={{
                                                    ...tableTdStyles,
                                                    backgroundColor:
                                                        selectedRowIndex === index ? "#f9faff" : "transparent",
                                                }}
                                            >   
                                            <Download onClick={() => handleFetchSignedUrl(item.id)} />
                                            </td>

                                        </tr>
                                        

                                        {/* Expanded Sub Section */}
                                        {/* {selectedRowIndex === index && (
                                            <tr>
                                                <td colSpan={headers.length + 1}>
                                                    <TableSubSection data={item} sections={sections} />
                                                </td>
                                            </tr>
                                        )} */}
                                    </React.Fragment>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={headers.length + 2} style={tableTdStyles}>
                                        No data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <Pagination
                    pagination={pagination}
                    postsPerPage={postsPerPage}
                    handlePageSizeChange={handlePageSizeChange}
                    fetchDetail={fetchDetail}
                />
            </div>

        </>
    );
}
